import { languageHelper } from "../../../config/helperFunctions";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { apiKey } from "../../../config/config";
import { toast } from "react-toastify";

function GeneralSetting() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));

  const [formData, setFormData] = useState({
    type: "currency",
    status: "enable",
    dateFormat: "",
    timeZone: "",
    value: "",
  })
  const navigate = useNavigate();

  const timeZones = [
    { label: "Asia/Dubai", value: "Asia/Dubai" },
    { label: "Asia/Karachi", value: "Asia/Karachi" },
    { label: "Asia/Riyadh", value: "Asia/Riyadh" },
    { label: "Asia/Qatar", value: "Asia/Qatar" },
    { label: "Asia/Kuwait", value: "Asia/Kuwait" },
    { label: "Asia/Bahrain", value: "Asia/Bahrain" },
    { label: "Asia/Muscat", value: "Asia/Muscat" },
    { label: "Asia/Tehran", value: "Asia/Tehran" },
    { label: "Asia/Kolkata", value: "Asia/Kolkata" },
    { label: "Asia/Dhaka", value: "Asia/Dhaka" },
    { label: "Asia/Colombo", value: "Asia/Colombo" },
    { label: "Asia/Kathmandu", value: "Asia/Kathmandu" },
    { label: "Asia/Bangkok", value: "Asia/Bangkok" },
    { label: "Asia/Singapore", value: "Asia/Singapore" },
    { label: "Asia/Kuala_Lumpur", value: "Asia/Kuala_Lumpur" },
    { label: "Asia/Jakarta", value: "Asia/Jakarta" },
    { label: "Asia/Manila", value: "Asia/Manila" },
    { label: "Asia/Tokyo", value: "Asia/Tokyo" },
    { label: "Asia/Seoul", value: "Asia/Seoul" },
    { label: "Asia/Shanghai", value: "Asia/Shanghai" },
    { label: "Asia/Hong_Kong", value: "Asia/Hong_Kong" },
    { label: "Europe/London", value: "Europe/London" },
    { label: "Europe/Paris", value: "Europe/Paris" },
    { label: "Europe/Berlin", value: "Europe/Berlin" },
    { label: "Europe/Rome", value: "Europe/Rome" },
    { label: "Europe/Madrid", value: "Europe/Madrid" },
    { label: "Europe/Istanbul", value: "Europe/Istanbul" },
    { label: "America/New_York", value: "America/New_York" },
    { label: "America/Chicago", value: "America/Chicago" },
    { label: "America/Denver", value: "America/Denver" },
    { label: "America/Los_Angeles", value: "America/Los_Angeles" },
    { label: "America/Toronto", value: "America/Toronto" },
    { label: "America/Sao_Paulo", value: "America/Sao_Paulo" },
    { label: "Australia/Sydney", value: "Australia/Sydney" },
    { label: "Australia/Melbourne", value: "Australia/Melbourne" },
    { label: "Africa/Cairo", value: "Africa/Cairo" },
    { label: "Africa/Johannesburg", value: "Africa/Johannesburg" }
  ];

  const dateFormats = [
    { label: "Y/M/D", value: "Y/M/D" },
    { label: "M/D/Y", value: "M/D/Y" },
    { label: "D/M/Y", value: "D/M/Y" },
  ];

  const handleChange = e => setFormData({ ...formData, [e.target.name]: e.target.value })

  const handleSubmit = e => {
    e.preventDefault()

    axios.put(`${apiKey}/api/rms/admin/settings/5`, formData, {
      headers: {
        Authorization: `Bearer ${user?.token}`,
      },
    })
      .then((res) => {
        toast.success(res.data.message || "Settings updated successfully")
      })
      .catch((err) => {
        toast.error(err.response.data.message || "Something went wrong")
      })
  }

  useEffect(() => {
    axios.get(`${apiKey}/api/rms/admin/settings/5`, {
      headers: {
        Authorization: `Bearer ${user?.token}`,
      },
    })
      .then((res) => {
        setFormData({
          ...JSON.parse(res.data.value),
          type: "currency",
          status: "enable",
          user_id: user?.user.id,
          outlet_id: user?.user.outlet_id,
        })
      })
      .catch((err) => {
        console.log(err);
      })
  }, [user?.token, user?.user.id, user?.user.outlet_id]);

  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-d-bg-text text-2xl">{languageHelper("General Setting")}</h1>
          </div>
        </div>
        <div className="w-full">
          <form
            action=""
            className="w-full"
            onSubmit={handleSubmit}
          >

            <div className="flex flex-col lg:flex-row gap-x-8 gap-y-2 w-full">
              <label htmlFor="" className="w-full lg:w-1/3">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold	">
                  {languageHelper("Date Format")}
                </span>
                <div className="mb-2 pt-0">
                  <Select
                    type="text"
                    options={dateFormats}
                    value={{ value: formData.dateFormat, label: formData.dateFormat }}
                    onChange={(e) => setFormData({ ...formData, dateFormat: e.value })}
                    placeholder="Y/M/D"
                    className="placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                  />
                </div>
              </label>
              <label htmlFor="" className="w-full lg:w-1/3">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  {languageHelper("Country Time Zone")}
                </span>
                <div className="mb-2 pt-0">
                  <Select
                    type="text"
                    placeholder={languageHelper("Select")}
                    options={timeZones}
                    value={{ value: formData.timeZone, label: formData.timeZone }}
                    onChange={(e) => setFormData({ ...formData, timeZone: e.value })}
                    className="placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
              <label htmlFor="" className="w-full lg:w-1/3">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  {languageHelper("Currency")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder={languageHelper("S.R")}
                    value={formData.value}
                    onChange={handleChange}
                    name="value"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                  />
                </div>
              </label>
            </div>

            <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="submit"
              >
                {languageHelper("Submit")}
              </button>
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="button"
                onClick={() => navigate(-1)}
              >
                {languageHelper("Back")}
              </button>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
}

export default GeneralSetting;
